import React from "react";
import "@Styles/mandate.css";
import Heading from "../Common/MainHeading";
import { HEADING_MANDATE } from "../Common/constant";

const Mandate = (props) => {
  return (
    <div className="main_div">
      <div className="container">
        <div className="pb-4">
          <Heading
            headingText={HEADING_MANDATE}
            backprops={"/DummyDashboard"}
            history={props.history}
          />
          <div className="wrapper-content">
            <div className="card-height px-4 pb-3 pt-1 w-100 mx-auto bg-gray rounded-40 shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-4 pb-5">
                  <div className="form-div">
                    <form action="#">
                      <div className="form-input-wrapper">
                        <label for="name">Account holder name</label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          placeholder="Enter name"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="mobile">Mobile number</label>
                        <input
                          type="number"
                          name="mobile"
                          id="mobile"
                          placeholder="Enter your mobile number"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="telephone">Telephone Number</label>
                        <input
                          type="number"
                          name="telephone"
                          id="telephone"
                          placeholder="Enter your telphone number"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="email">Email</label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Enter your email address"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="account-type">Account type</label>
                        <select name="account-type" id="account-type">
                          <option value="">Select Account</option>
                          <option value="one">one</option>
                          <option value="two">two</option>
                        </select>
                      </div>
                      <div className="form-input-wrapper">
                        <label for="account-number">Account number</label>
                        <input
                          type="number"
                          name="account-number"
                          id="account-number"
                          placeholder="Enter account number"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="account-number">
                          Confirm Account number
                        </label>
                        <input
                          type="number"
                          name="account-number"
                          id="account-number"
                          placeholder="Re-enter account number"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="debit-amount">Max debit amount</label>
                        <input
                          type="number"
                          name="debit-amount"
                          id="debit-amount"
                          placeholder="Enter amount"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="s-date">Start date</label>
                        <input
                          type="date"
                          name="s-date"
                          id="s-date"
                          placeholder="Enter start date"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="e-date">End date</label>
                        <input
                          type="date"
                          name="e-date"
                          id="e-date"
                          placeholder="Enter end date"
                        />
                      </div>
                      <div className="form-input-wrapper">
                        <label for="p-mandate">Purpose of mandate</label>
                        <select name="p-mandate" id="p-mandate">
                          <option value="">Select Purpose</option>
                          <option value="one">one</option>
                          <option value="two">two</option>
                        </select>
                      </div>
                      <div className="form-input-wrapper">
                        <label for="bank">Bank</label>
                        <select name="bank" id="bank">
                          <option value="">Select Bank</option>
                          <option value="one">one</option>
                          <option value="two">two</option>
                        </select>
                      </div>
                      <div className="form-input-wrapper">
                        <label for="frequency">Frequency</label>
                        <select name="frequency" id="frequency">
                          <option value="">Select Frequency</option>
                          <option value="one">one</option>
                          <option value="two">two</option>
                        </select>
                      </div>
                      <div className="form-input-wrapper">
                        <label for="a-mode">Authentication Mode</label>
                        <select name="a-mode" id="a-mode">
                          <option value="">Select</option>
                          <option value="one">one</option>
                          <option value="two">two</option>
                        </select>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="checkbox-sc">
            <label class="main-check">
              I have read the above and agree to the terms
              <input type="checkbox" />
              <span class="geekmark"></span>
            </label>
          </div>
          <div class="button-wrapper text-center">
            <button className="btn bg-orange text-white rounded-pill px-5 py-3">
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mandate;
